import { QuantitySelectorUpdateEvent } from '@theme/events';

/**
 * Lightweight quantity stepper for the cart drawer.
 *
 * The theme's native <cart-quantity-selector-component> is emptied by the drawer's
 * initial hydration, leaving only a trash button. Rather than fight that, we render
 * plain [-] n [+] buttons in the drawer (see snippets/cart-products.liquid) and, on
 * click, dispatch the SAME QuantitySelectorUpdateEvent the native selector would.
 *
 * CartItemsComponent already listens for this event and handles everything:
 * AJAX /cart/change, section morph, XBoost/bundle + automatic discounts, and
 * quantity === 0 -> remove the line. We simply reuse that pipeline.
 *
 * A single delegated listener on the document survives every drawer re-render/morph.
 */
if (!window.__cartDrawerQtyBound) {
  window.__cartDrawerQtyBound = true;

  document.addEventListener('click', (event) => {
    const button =
      event.target instanceof Element ? event.target.closest('[data-cart-qty-change]') : null;
    if (!button) return;

    const control = button.closest('[data-cart-qty]');
    if (!control) return;

    event.preventDefault();

    const line = Number(control.getAttribute('data-line'));
    if (!line) return;

    const delta = Number(button.getAttribute('data-cart-qty-change'));
    const valueEl = control.querySelector('[data-cart-qty-value]');
    const current = Number((valueEl?.textContent || '').trim()) || 0;
    const newQuantity = Math.max(0, current + delta);

    if (newQuantity === current) return;

    // Optimistic display update; the section morph will confirm/correct it.
    if (valueEl && newQuantity > 0) valueEl.textContent = String(newQuantity);
    control.setAttribute('aria-busy', 'true');

    // Reuse the theme's own cart pipeline (change + morph + discounts + remove-at-0).
    button.dispatchEvent(new QuantitySelectorUpdateEvent(newQuantity, line));
  });
}
